module.exports = __webpack_public_path__ + "img/img-cate1.2beef921.webp";